import React from "react";

function PlusIcon({ css, color = "black" }) {
  const dynamic_color = color;

  if (color == "black") {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        x="0px"
        y="0px"
        width="12"
        height="10"
        fill="none"
        viewBox="0 0 24 24"
      >
        <path
          fillRule="evenodd"
          stroke={color}
          strokeWidth="2"
          d="M 11 2 L 11 11 L 2 11 L 2 13 L 11 13 L 11 22 L 13 22 L 13 13 L 22 13 L 22 11 L 13 11 L 13 2 Z"
        ></path>
      </svg>
    );
  } else {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        x="0px"
        y="0px"
        width="12"
        height="10"
        fill="none"
        viewBox="0 0 24 24"
      >
        <path
          fillRule="evenodd"
          stroke={color}
          strokeWidth="2"
          d="M 11 2 L 11 11 L 2 11 L 2 13 L 11 13 L 11 22 L 13 22 L 13 13 L 22 13 L 22 11 L 13 11 L 13 2 Z"
        ></path>
      </svg>
    );
  }
}

export default PlusIcon;
